module.exports = __webpack_public_path__ + "static/media/partners.f5659153.svg";